<template>
 <div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // locationList: [],
      // array: []
    }
  },
  created () {
    // this.init3()
    window.location.replace('aed://com.gov.red.aed/xxxxx')
  },
  mounted () {
    // this.init()
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homepage_docs.vue